export const MORE_INFO_LINKS: InfoLink[] = [
  {
    label: 'Tradicionais',
    icon: 'candy',
  },
  {
    label: 'Gourmet',
    icon: 'cheff',
  },
  {
    label: 'Castanhas',
    icon: 'peanut',
  },
  {
    label: 'Etílicos',
    icon: 'drink',
  },
  {
    label: 'Banhados',
    icon: 'shower',
  },
  {
    label: 'Artesanais',
    icon: 'heart',
  },
  {
    label: 'Exóticos',
    icon: 'palmtree',
  },
];
